import { Avatar, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { generateColor } from '../../helpers/random-color';

const useStyles = makeStyles(theme => ({
    avatar: {
        color: "#fffc",
        background:
            theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[600],
        width: 32,
        height: 32,
        fontSize: 14,
        fontWeight: 500
    },
    same: {
        background: theme.palette.info.dark
    }
}));

export default function UserAvatar({ username, className }) {
    const classes = useStyles();

    return (
        <Avatar
            className={clsx(classes.avatar, className)}
            style={username ? { backgroundColor: generateColor(username) } : {}}
        >
            {(username || '?')[0].toUpperCase()}
        </Avatar>
    );
}